module.exports = __webpack_public_path__ + "img/box63.e2eada35.png";